import React, { useState } from "react";
import { Button, LinearProgress, Typography, Box } from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "../../utils/api";

const BulkInviteButton = ({ selectedUsers, onSuccess }) => {
  const [isSending, setIsSending] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);

  const handleBulkInvite = async () => {
    if (!selectedUsers.length) return;
    const confirmed = window.confirm(
      `Send invitation emails to ${selectedUsers.length} user(s)?`
    );

    if (!confirmed) return;

    setIsSending(true);
    setProgress(0);
    setCurrentUser(null);

    try {
      const total = selectedUsers.length;
      let successCount = 0;
      let failureCount = 0;

      for (let i = 0; i < total; i++) {
        const username = selectedUsers[i];
        setCurrentUser(username);

        try {
          await axios.post(`${API_BASE_URL}/send-user-invitations`, {
            usernames: [username], // ✅ one by one
          });
          successCount++;
        } catch (err) {
          console.error(`Failed to invite ${username}`, err);
          failureCount++;
        }

        // update progress
        setProgress(Math.round(((i + 1) / total) * 100));
      }

      alert(`Invitations complete.\n✅ Sent: ${successCount}\n❌ Failed: ${failureCount}`);
      onSuccess?.(); // callback if provided
    } catch (err) {
      console.error("Bulk invite error", err);
      alert("Failed to send invitations.");
    } finally {
      setIsSending(false);
      setCurrentUser(null);
      setProgress(0);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "flex-start" }}>
      <Button
        variant="outlined"
        color="secondary"
        disabled={selectedUsers.length === 0 || isSending}
        onClick={handleBulkInvite}
      >
        {isSending ? "Sending..." : "Send Invitations to Selected"}
      </Button>

      {isSending && (
        <Box sx={{ width: "100%", mt: 1 }}>
          <LinearProgress variant="determinate" value={progress} />
          <Typography variant="body2" sx={{ mt: 1 }}>
            {progress}% — Sending to <strong>{currentUser}</strong>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default BulkInviteButton;
